function setErrorMessage(state, message) {
  state.error = true
  state.valid = false
  if (state.errorWrap) state.errorWrap.innerHTML = message
}

export default setErrorMessage
